// Sign-in with Imprion ID (README decision 328). The browser holds no token:
// the API keeps the session behind one HttpOnly cookie, which every request,
// image and download on this origin carries by itself.

export const AUTH_BASE_PATH = '/api/imprion-pos-server/v1/auth'

/** The API's sign-in: a full-page navigation to Imprion ID and back to `returnTo`. */
export const loginUrl = (returnTo: string): string =>
    `${AUTH_BASE_PATH}/login?${new URLSearchParams({ return_to: returnTo }).toString()}`

/** Imprion ID's own page; a refused sign-in has no session to read `profile_url` from. */
export const IMPRION_ID_PROFILE_URL = 'https://id.imprion.cloud/'
